import React from 'react';

export function Textarea({ invalid = false, rows = 4, className = '', ...rest }) {
  return (
    <textarea
      rows={rows}
      className={['sp-input', 'sp-textarea', invalid && 'sp-input--invalid', className].filter(Boolean).join(' ')}
      aria-invalid={invalid || undefined}
      {...rest}
    />
  );
}
